import { createListenerMiddleware } from "@reduxjs/toolkit";
import { incomingNotification } from "@store/slices/notification.actions";
import { addNotification, fetchHeaderNotifications } from "./notificationSlice";
import { RootState } from "@store/store";

export const notificationListener = createListenerMiddleware();

notificationListener.startListening({
  actionCreator: incomingNotification,

  effect: async (action, { dispatch, getState }) => {
    const state = getState() as RootState;

    const isLoggedIn = state.auth.isAuthenticated;
    const userRole = state.auth.user?.role; // ADMIN | AGENT | CURATOR

    const notificationRole = action.payload?.data?.receiver_type;

    if (!isLoggedIn) return;

    if (notificationRole && notificationRole !== userRole) return;

    dispatch(addNotification(action.payload));

    const rawIsRead = action.payload?.data?.is_admin_read;
    const isRead = rawIsRead !== undefined ? String(rawIsRead) === "true" : false;

    if (!isRead) {
      dispatch(fetchHeaderNotifications());
    }
  },
});
